import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types/lib/DateFromUnixTime';
import { authorizedTo, meta } from '../..';

const data = t.type({
  subject: t.string,
  message: t.string,
  createdAt: DateFromUnixTime,
  readAt: t.union([DateFromUnixTime, t.null]),
});

export const recordCodec = t.type({
  id: t.string,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = data;
